import * as _ from "lodash";

import {
    UserDto,
    GroupDto,
    RoleDto,
    AssignedGroupRoleDto,
    AssignedUserRoleDto,
    ResourceListOfUserDto,
    ResourceListOfGroupDto,
    ResourceListOfRoleDto,
    ProMTGroupDto,
    LanguageCnrDto,
    ResourceListOfLanguageCnrDto
} from "../../services/Client";

type ResourceListTypes = undefined | ResourceListOfUserDto | ResourceListOfGroupDto | ResourceListOfRoleDto | ResourceListOfLanguageCnrDto;
type DtoTypes = UserDto | GroupDto | RoleDto | LanguageCnrDto;

/** Extract the DTO elements from a given ResourceListOf*Dto back end response. */
export const getDtoArray = <T extends DtoTypes>(res: ResourceListTypes): T[] => {
    const dtos = res && res.elements && res.elements;
    return dtos ? dtos as T[] : [];
};

export const createAssignedUserRoles = (roles: RoleDto[], dto: UserDto): AssignedUserRoleDto[] => {
    const assignedRoles: AssignedUserRoleDto[] = [];
    roles.forEach(role => {
        // check if a given role already exists in the parent object
        const existingRole = _.find(dto.assignedRoles, arole => (arole.role !== undefined ? arole.role.name === role.name : false));
        if (existingRole !== undefined) {
            // use existing role(s) from the parent object
            assignedRoles.push(existingRole);
        } else {
            // break circular dependency; otherwise JSON serialization fails during REST request.
            const userRoleDto = Object.assign({}, dto, {assignedRoles: undefined});
            // create a new assigned role for the role
            assignedRoles.push({
                user: userRoleDto,
                role: role,
                objectId: 0, // dummy objectId for creation
                versionId: 0, // dummy versionId for creation
            });
        }
    });
    return assignedRoles;
};

export const createAssignedGroupRoles = (roles: RoleDto[], dto: GroupDto): AssignedGroupRoleDto[] => {
    const assignedRoles: AssignedGroupRoleDto[] = [];
    roles.forEach(role => {
        // check if a given role already exists in the parent object
        const existingRole = _.find(dto.assignedRoles, arole => (arole.role !== undefined ? arole.role.name === role.name : false));
        if (existingRole !== undefined) {
            // use existing role(s) from the parent object
            assignedRoles.push(existingRole);
        } else {
            // break circular dependency; otherwise JSON serialization fails during REST request.
            const groupRoleDto = Object.assign({}, dto, {assignedRoles: undefined});
            // create a new assigned role for the role
            assignedRoles.push({
                group: groupRoleDto,
                role: role,
                objectId: 0, // dummy objectId for creation
                versionId: 0, // dummy versionId for creation
            });
        }
    });
    return assignedRoles;
};

export const createAssignedProMTGroupRoles = (roles: RoleDto[], dto: ProMTGroupDto): RoleDto[] => {
    const assignedRoles: RoleDto[] = [];
    roles.forEach(role => {
        // check if a given role already exists in the parent object
        const existingRole = _.find(dto.assignedRoles, arole => (arole.name === role.name ));
        if (existingRole !== undefined) {
            // use existing role(s) from the parent object
            assignedRoles.push(existingRole);
        } else {
            // create a new assigned role for the role
            assignedRoles.push(role);
        }
    });
    return assignedRoles;
};

export const createAssignedProMTGroupGroups = (groups: GroupDto[], dto: ProMTGroupDto): GroupDto[] => {
    const assignedGroups: GroupDto[] = [];
    groups.forEach(group => {
        // check if a given role already exists in the parent object
        const existingGroup = _.find(dto.assignedGroups, aGroup => (aGroup.groupName === group.groupName ));
        if (existingGroup !== undefined) {
            // use existing role(s) from the parent object
            assignedGroups.push(existingGroup);
        } else {
            // create a new assigned role for the role
            assignedGroups.push(group);
        }
    });
    return assignedGroups;
};

export const createAssignedProMTGroupUsers = (users: UserDto[], dto: ProMTGroupDto): UserDto[] => {
    const assignedUsers: UserDto[] = [];
    users.forEach(user => {
        // check if a given role already exists in the parent object
        const existingUser = _.find(dto.assignedUsers, aUser => (aUser.cn === user.cn ));
        if (existingUser !== undefined) {
            // use existing role(s) from the parent object
            assignedUsers.push(existingUser);
        } else {
            // create a new assigned role for the role
            assignedUsers.push(user);
        }
    });
    return assignedUsers;
};

/** Search and return the RoleDto objects from a given Assigned*RoleDto array. */
export const extractRoles = (assignedRoles: AssignedUserRoleDto[] | AssignedGroupRoleDto[]): RoleDto[] => {
    // Cast to 'any' because Array.map() doesn't work on union types even though both,
    // AssignedUserRoleDto and AssignedGroupRoleDto, have the 'role' property.
    const anyAssignedRoles = assignedRoles as any;
    return anyAssignedRoles.map((assignedRole: any) => assignedRole.role || undefined);
};



// WEBPACK FOOTER //
// ./src/views/AdminView/AdminUtils.ts